<template>
  <div>
    <Breadcrumb :levelList="levelList"/>
    <div class="aibfb aimt20 pull-left">
      <el-button class="pull-right" type="primary" size="small" @click="goOff()">返 回</el-button>
      <div class="entity_sysSearchOne aimr10 pull-right">
        <el-input placeholder="添加关键字" class="selectInput pull-right" v-model="entity_addsearch" size="small">
          <svg slot="suffix" class="icon" aria-hidden="true" @click="search(1)">
            <use xlink:href="#iconsearchicon" />
          </svg>
        </el-input>
      </div>
      <el-select class="pull-right aimr10 entity_w130" size="small" v-model="entity_sysSelect" placeholder="所有状态" clearable>
        <el-option label="待标注" :value="1"></el-option>
          <el-option label="待训练" :value="2"></el-option>
          <el-option label="已训练" :value="3"></el-option>
      </el-select>
    </div>
    <div class="aibfb aimt10 pull-left tagTable" v-loading="trainLoad">
      <el-table ref="corpusTableData" :data="tableData" style="width:100%" @selection-change="selectionChange" @sort-change="handleFilterChange">
        <el-table-column type="selection" width="55" :show-overflow-tooltip="false"></el-table-column>
        <el-table-column label="语料" show-overflow-tooltip>
          <template slot-scope="scope">
              <span style="cursor: pointer" @click="setOpenKey('entityInfo', { id: dataId, pData: scope.row })"><span v-html="toHtml(scope.row)"></span></span>
            <!--<div class="entity_tableColor0 pull-left aimr10" align="left">{{ scope.row.corpus0 }}</div>
            <div @click="drawerListTag = true">
              <div class="entity_tableColor1 pull-left aimr10" align="left">{{ scope.row.corpus }}</div>
              <div class="entity_tableColor2 pull-left aimr10" align="left">{{ scope.row.corpus1 }}</div>
              <div class="entity_tableColor3 pull-left aimr10" align="left">{{ scope.row.corpus2 }}</div>
            </div>-->
          </template>
        </el-table-column>
        <el-table-column prop="commentsNumber" label="标注量" sortable="custom" width="120"></el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 2" style="color:#666666">待训练</span>
            <span v-if="scope.row.status == 3" style="color:#337eff">已训练</span>
            <span v-if="scope.row.status == 1" style="color:#f66f6a">待标注</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="aibfb aimt20 pull-left text-right">
        <Page v-bind:init_item="pageBuild" @currentPage="currentPage"/>
    </div>
    <div class="aibfb entity_sysfooter">
      <el-button class="pull-left" type="info" size="small" icon="el-icon-plus" @click="setOpenKey('entityInfo', { id: dataId, pData: undefined })">新增</el-button>
      <el-button class="pull-left" size="small" @click="deleteIds()">删除</el-button>
      <!--<el-button class="pull-left" type="primary" size="small" @click="entityImportPopup = true">导入</el-button>
      <el-button class="pull-left" type="primary" size="small">导出</el-button>-->
      <el-button size="small" @click="traind()">训练已标注内容</el-button>
    </div>
    <!--<el-dialog class="entityImportPopup aiPopup" title="导入语料" :visible.sync="entityImportPopup" width="480px">
      <el-row class="pull-left aibfb aimb20">
        <el-form ref="form" :model="entityImportForm" label-width="50px">
          <el-form-item label="文件">
            <div class="pull-left aibfb aiupLoadBtnBox">
              <el-input class="aiImport-input pull-left" size="small" placeholder="文件名称" v-model="entityImportBoxName"></el-input>
              <el-upload class="pull-right" size="small" action="https://jsonplaceholder.typicode.com/posts/"
                         :on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove" :file-list="upLoadFile">
                <el-button class="pull-right" size="small">上传文件</el-button>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="" size="mini">
            <div class="pull-left aibfb aimt5">
              <el-checkbox v-model="entityImportChecked">清空导入</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item label="" size="mini">
            <div class="pull-left aibfb entityImportTxt">
              提示：*实体标注的语料导入导出格式只有一列：语料
            </div>
          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer" style="margin: 0 -20px">
          <el-button @click="entityImportPopup = false" size="medium">取 消</el-button>
          <el-button type="primary" @click="entityImportPopup = false" size="medium">确 定</el-button>
        </span>
    </el-dialog>-->
    <el-drawer class="entity_drawerBox" size="450px" title="" :visible.sync="drawerListTag">
        <InfoVue v-bind:openData="openData" v-if="drawerListTag" @loadPage="loadPage"/>
    </el-drawer>
   <!-- <el-drawer class="entity_drawerBox" size="450px" title="" :visible.sync="drawerAddTag">
        <InfoVue/>
    </el-drawer>-->
  </div>
</template>

<script>
import Breadcrumb from '@/views/components/crm/Breadcrumb'
import InfoVue from './info'
import Page from '../../../components/PageComponent'
import { getCorpusList, deleteCorpuss, train } from '../../../../../api/entity/entity'
export default {
  name: 'index',
  components: { Breadcrumb, InfoVue, Page },
  props: ['tagMainData'],
  data() {
    return {
      levelList: [{ path: '@/views/entity/custom/tag/label', title: '实体标注' }],
      entity_addsearch: '',
      entity_sysSelect: '',
      entityImportPopup: false,
      entityImportChecked: false,
      entityImportBoxName: '',
      upLoadFile: [],
      drawerAddTag: false,
      corpusTableData: [{
        corpus: '金沙将西路1555号',
        corpus1: '小i机器人',
        dimension: '1',
        state: '待训练'
      }, {
        corpus: '金沙将西路1555号',
        corpus1: '小i机器人',
        corpus2: '金沙将西路1555号',
        dimension: '0',
        state: '已训练'
      }, {
        corpus0: '速度快放假看电视  大幅降低刷卡 快递费就开始就',
        dimension: '5',
        state: '待标注'
      }],
      entityImportForm: {
      },
      optionsOne: [{
        value: '1',
        label: '所有分类'
      }, {
        value: '2',
        label: '香港实体标签'
      }, {
        value: '3',
        label: '工单'
      }],
      optionsTwo: [{
        value: '1',
        label: '所有分类'
      }, {
        value: '2',
        label: '香港实体标签'
      }, {
        value: '3',
        label: '工单'
      }],
      // ======== new
      drawerListTag: false,
      tableData: [],
      dataId: '',
      selectIds: [],
      pageBuild: {
        page_size: 10,
        total: 0,
        currentPage: 1
      },
      openData: {},
      trainLoad: false,
      tableOrder: ''
    }
  },
  methods: {
    handleFilterChange (data) {
      // orderBy
      if (data.order) {
        this.tableOrder = data.order === 'ascending' ? 'ASC' : 'DESC'
      } else {
        this.tableOrder = null
      }
      this.search(1)
    },
    traind() {
      this.trainLoad = true
      train({ id: this.dataId }).then(response => {
        this.trainLoad = false
        if (response.data.code === 2000) {
          window.entityMessage({ type: 'success', text: '训练成功' })
          this.search(1)
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        this.trainLoad = false
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    getRandomId() {
      const randomNum = Math.random()
      let checkCode = randomNum * 9000
      checkCode += 1000
      const id = new Date().getTime() + '_entity_' + parseInt(checkCode)
      return id
    },
    toHtml (item) {
      let text = item ? item.content : ''
      const that = this
      const tagList = []
      if (item && item.commentsNumber > 0) {
        item.entityCorpusMarkList.forEach(function (item) {
          const json = {
            id: that.getRandomId(),
            tagId: item.tagId,
            start: item.markStartIndex,
            lengthNumber: item.markLength,
            text: item.tagName,
            color: item.tagColor
          }
          tagList.push(json)
        })
      }
      if (text !== undefined && text !== null) {
        if (tagList && tagList.length > 0) {
          const htmlList = []
          tagList.forEach(function (tag) {
            let start = 0
            htmlList.forEach(function (htm) {
              if (tag.start > htm.start) {
                start += (htm.html.length - htm.text.length)
              }
            })
            start += tag.start
            // 生成html
            const id = tag.id
            const htmls = '<span style="color: ' + tag.color + '">' + text.substring(start, start + tag.lengthNumber) + '</span>'
            let startText = ''
            if (tag.start !== 0) {
              startText = text.substring(0, start)
            }
            const endText = text.substring(start + tag.lengthNumber) || ''
            htmlList.push({
              id: id,
              start: tag.start,
              html: htmls,
              text: text.substring(start, start + tag.lengthNumber)
            })
            text = startText + htmls + endText
          })
        } else {
          return text
        }
      }
      return text
    },
    goOff() {
      this.$emit('toIndex', 'list', {})
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      console.log(file)
    },
    // ====== new
    currentPage(currentPage) {
      this.pageBuild.currentPage = currentPage
      this.search(currentPage)
    },
    search(pageNumber) {
      this.selectIds = []
      this.tableData = []
      this.pageBuild.currentPage = pageNumber
      const that = this
      const params = {
        search: this.entity_addsearch,
        entityId: this.dataId,
        page: pageNumber,
        limit: this.pageBuild.page_size,
        status: this.entity_sysSelect,
        orderBy: this.tableOrder
      }
      getCorpusList(params).then(response => {
        if (response.data.code === 2000) {
          const data = response.data.data
          if (data) {
            this.pageBuild.total = data.totalProperty || 0
            if (data.root && data.root.length > 0) {
              data.root.forEach(function (item) {
                const json = {
                  ...item,
                  text: item.content,
                  commentsNumber: item.entityCorpusMarkList.length,
                  id: item.id,
                  status: item.status,
                  chickBoxValue: true
                }
                that.tableData.push(json)
              })
            }
          } else {
            this.pageBuild.total = 0
          }
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    selectionChange(select) {
      this.selectIds = []
      const that = this
      if (select && select.length > 0) {
        select.forEach(function (item) {
          that.selectIds.push(item.id)
        })
      }
    },
    deleteIds() {
      const that = this
      if (this.selectIds.length === 0) {
        window.entityMessage({ type: 'warning', text: '请选择要删除的语料' })
      } else {
        window.entityMessageBox({
          title: '提示',
          text: '此操作将永久删除, 是否继续?',
          f: function() {
            that.deleteAll()
          },
          c: function() {
          }
        })
      }
    },
    deleteAll() {
      deleteCorpuss(this.selectIds).then(response => {
        if (response.data.code === 2000) {
          this.search(1)
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    setOpenKey(type, item) {
      this.openData = item
      this.drawerListTag = true
    },
    loadPage() {
      this.search(1)
      this.drawerListTag = false
    }
  },
  mounted() {
    this.dataId = this.tagMainData.id
    this.search(1)
  }
}
</script>

<style scoped>
.aiPopup .aiupLoadBtnBox .el-input{right:90px;}
.el-dropdown-menu--small{padding:0px 0 3px;}
.el-dropdown-menu--small .el-dropdown-menu__item.el-dropdown-menu__item--divided{margin-top:0px;}
.el-dropdown-menu--small{min-width:120px;}
.el-dropdown-menu--small .el-dropdown-menu__item.el-dropdown-menu__item--divided:before{height:0px;}
.el-dropdown-menu--small .el-dropdown-menu__item{line-height:30px;}
.el-dropdown-menu__item.is-disabled{color:#333333;}
</style>
